import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";

export const TagInput = ({ label, values, onChange, placeholder, testId }) => {
  const [text, setText] = useState("");
  const add = () => {
    const v = text.trim();
    if (v && !values.includes(v)) onChange([...values, v]);
    setText("");
  };
  return (
    <div className="space-y-1.5">
      <Label>{label}</Label>
      <div className="flex gap-2">
        <Input data-testid={testId} value={text} placeholder={placeholder}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              add();
            }
          }}
          className="rounded-xl bg-card" />
        <Button type="button" variant="outline" onClick={add} className="rounded-xl border bg-card hover:bg-muted">Add</Button>
      </div>
      <div className="flex flex-wrap gap-1.5">
        {values.map((v) => (
          <Badge key={v} variant="secondary" className="rounded-full">
            {v}
            <button type="button" className="ml-1.5 opacity-60 hover:opacity-100" onClick={() => onChange(values.filter((x) => x !== v))}>×</button>
          </Badge>
        ))}
      </div>
    </div>
  );
};
